export default function formatNumber(num) {

    let convertNumber = new Intl.NumberFormat('en-US');
    return convertNumber.format(num)
    
}